import { AddOutlined } from "@mui/icons-material";
import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MapType } from "../../../hooks/map.type";
import { VIEW } from "../../../utils/breakpoint";
import { COLOR } from "../../../utils/colors";
import LayoutMapTable from "../quick-setup/_components/layout-map-table";

export default function ListLayoutMapPage({
  onSubmit,
  onCancel,
  onBack,
  showCancel = false,
  showBack = false
}: {
  onSubmit?: (layoutMaps: MapType[]) => void,
  onCancel?: () => void,
  onBack?: () => void,
  showCancel?: boolean,
  showBack?: boolean
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedLayoutMaps, setSelectedLayoutMaps] = useState<MapType[]>([])

  const navigate = useNavigate()
  const onHandleNext = () => {
    onSubmit?.(selectedLayoutMaps)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              color: COLOR.neutral[900]
            }}
          >
            Bind Robot Map GIS Points
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: COLOR.neutral[900],
              opacity: 0.6,
            }}
          >
            Select Layout Map to bind with the Robot Map
          </Typography>
        </Box>
        <Box sx={(theme) => ({
          display: 'flex',
          gap: '12px',
          marginTop: '16px',
          [theme.breakpoints.down(VIEW.TABLET)]: {
            flexDirection: 'column'
          }
        })}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Layout Map'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Link to="/config/layout-maps/create">
            <Button variant="outlined" sx={{ height: '40px' }} startIcon={<AddOutlined />}>
              New Layout Map
            </Button>
          </Link>
        </Box>
      </Box>
      <LayoutMapTable search={searchTerm} isDefaultMockFilled selectable onSelectedChange={(val) => setSelectedLayoutMaps(val)} />
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        {showCancel && (
          <Button onClick={() => onCancel?.()} variant="outlined" sx={{ marginRight: '12px' }}>Cancel</Button>
        )}
        {showBack && (
          <Button onClick={() => onBack?.()} variant="outlined" sx={{ marginRight: '12px' }}>Back</Button>
        )}
        <Button onClick={onHandleNext} variant="contained" disabled={selectedLayoutMaps.length === 0}>Next</Button>
      </Box>
    </Box>
  );
}